import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTrophy} from '@fortawesome/free-solid-svg-icons';

const TrophyFAPage = () => {
  const authState = useSelector(state => state.authReducer);
  const user = useSelector(state => state.user);
  const applausecount = 5650;
  const badgescount = Math.floor(applausecount)/10;
  const certificatescount = Math.floor(badgescount)/20;
  const trophiescount = Math.floor(certificatescount)/5;

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', color: 'yellow' }}>
       <FontAwesomeIcon icon={faTrophy} style={{ fontSize: '200px' }}/>
      <div style={{ textAlign: 'center' }}>
        <h2>
          {authState.user && authState.user.name
            ? `Hello ${authState.user.name}! You have earned ${Math.floor(trophiescount)} Trophies`
            : `Hello! You have earned ${Math.floor(trophiescount)} Trophies`}
        </h2>
      </div>
      <div style={{ textAlign: 'center', fontSize: '24px' }}>
      <p>Rule - For Every 5 Certificates You Earn 1 Trophy.</p>
    </div>
    </div>


  );
};

export default TrophyFAPage;
